import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  border: " 1px solid black",
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));

function BillingDepartmentEmployeeReport() {
  const mystyle = {
    border: " 1px solid black",fontFamily: 'Times New Roman',
    width: "12rem",
  };
  const mystyle1 = {
    fontWeight: "bolder",fontFamily: 'Times New Roman',
    color: "#0b64c5",
  };

  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [exportExcelProcs, setexportExcelProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [loading, setloading] = useState(false)
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [billEmpValues, setbillEmpValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: 'ALL',
    empname: 'ALL',
  });
  const fromhandlechange = (e) => {
    setbillEmpValues({ ...billEmpValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setbillEmpValues({ ...billEmpValues, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setbillEmpValues({ ...billEmpValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const empnmhandlechange = (e) => {
    setbillEmpValues({ ...billEmpValues, empname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///getfunctions
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    OperationReportService.getEmployeeDetails().then(res => {
      setdetails2(res.data);
    })
  }
  // btnOperations
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var employeeId, regionalId = '';
    if (billEmpValues.empname === 'ALL') {
      employeeId = -1
    } else {
      employeeId = billEmpValues.empname;
    }
    if (billEmpValues.branch === 'ALL') {
      regionalId = -1
    } else {
      regionalId = billEmpValues.branch;
    }
    let details = { fromDate: billEmpValues.from, toDate: billEmpValues.to, employeeId: employeeId, regionalId: regionalId, flag: 1 };
    OperationReportService.getBillingDepEmployeeReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const ExportExcelClick = () => {
    setexportExcelProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setexportExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].operationType !== '') {
          tableContent = details3[i].operationType + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].consignmentNumber !== '') {
          tableContent += details3[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].status !== '') {
          tableContent += details3[i].status + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].regionalName !== '') {
          tableContent += details3[i].regionalName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].customPointName !== '') {
          tableContent += details3[i].customPointName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_name !== '') {
          tableContent += details3[i].importer_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].forwarder_name !== '') {
          tableContent += details3[i].forwarder_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawbNo !== '') {
          tableContent += details3[i].mawbNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawb_date !== '') {
          tableContent += details3[i].mawb_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawb_no !== '') {
          tableContent += details3[i].hawb_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawbDate !== '') {
          tableContent += details3[i].hawbDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].IgmNo !== '') {
          tableContent += details3[i].igmNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igmDate !== '') {
          tableContent += details3[i].igmDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalPcs !== '') {
          tableContent += details3[i].totalPcs + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalWeight !== '') {
          tableContent += details3[i].totalWeight + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beType !== '') {
          tableContent += details3[i].beType + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].boe_no !== '') {
          tableContent += details3[i].boe_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].boe_date !== '') {
          tableContent += details3[i].boe_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalInvoice !== '') {
          tableContent += details3[i].totalInvoice + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceValue !== '') {
          tableContent += details3[i].invoiceValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalCarton !== '') {
          tableContent += details3[i].totalCarton + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].assbleValue !== '') {
          tableContent += details3[i].assbleValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyAmount !== '') {
          tableContent += details3[i].dutyAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].drawbackAmt !== '') {
          tableContent += details3[i].drawbackAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].currency_code !== '') {
          tableContent += details3[i].currency_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].billGenDate !== '') {
          tableContent += details3[i].billGenDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].billGenBy !== '') {
          tableContent += details3[i].billGenBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].billTaxable !== '') {
          tableContent += details3[i].billTaxable + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].billNonTaxable !== '') {
          tableContent += details3[i].billNonTaxable + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].billTax !== '') {
          tableContent += details3[i].billTax + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelVeryDate !== '') {
          tableContent += details3[i].firstLevelVeryDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelVeryBy !== '') {
          tableContent += details3[i].firstLevelVeryBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelVeryTaxable !== '') {
          tableContent += details3[i].firstLevelVeryTaxable + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelVeryNonTaxable !== '') {
          tableContent += details3[i].firstLevelVeryNonTaxable + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelVeryTax !== '') {
          tableContent += details3[i].firstLevelVeryTax + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelVeryDate !== '') {
          tableContent += details3[i].secondLevelVeryDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelVeryBy !== '') {
          tableContent += details3[i].secondLevelVeryBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelVeryTaxable !== '') {
          tableContent += details3[i].secondLevelVeryTaxable + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelVeryNonTaxable !== '') {
          tableContent += details3[i].secondLevelVeryNonTaxable + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelVeryTax !== '') {
          tableContent += details3[i].secondLevelVeryTax + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoicePrintDate !== '') {
          tableContent += details3[i].invoicePrintDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoicePrintBy !== '') {
          tableContent += details3[i].invoicePrintBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceSendPartyDate !== '') {
          tableContent += details3[i].invoiceSendPartyDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceSendPartyBy !== '') {
          tableContent += details3[i].invoiceSendPartyBy + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,BILLING DEPARTMENT EMPLOYEE REPORT", headerDetails: "1,1,FROM DATE : " + billEmpValues.from + "/4,1,TO DATE : " + billEmpValues.to,
        tableHeader: "0,3,Sl.No/1,3,Operation/2,3,Job No/3,3,Job Status/4,3,Branch/5,3,Edi Location/6,3,Customer Name/7,3,Forwarder Name/8,3,MAWB_MBL No/9,3,MAWB_MBL Date/10,3,HAWB_HBL No/11,3,HAWB_HBL Date/12,3,IGM No/13,3,IGM Date/14,3,Total Pcs/15,3,Total Weight/16,3,BE_SB Type/17,3,BE_SB No/18,3,BE_SB Date/19,3,No of Invoice/20,3,Total Invoice Value/21,3,No of Item/22,3,Asseseble Value/23,3,Duty Amount/24,3,Drawback Amount/25,3,Invoice Currency/26,3,Bill Generated Date/27,3,Bill Generated By/28,3,Bill Taxable Amount/29,3,Bill NonTaxable Amount/30,3,Bill Tax Amount/31,3,FirstLevel Verify Date/32,3,FirstLevel Verify By/33,3,FirstLevelVerify TaxableAmount/34,3,FirstLevelVerify NonTaxableAmount/35,3,FirstLevelVerify TaxAmount/36,3,SecondLevel Verify Date/37,3,SecondLevel Verify By/38,3,SecondLevelVerify TaxableAmount/39,3,SecondLevelVerify NonTaxableAmount/40,3,SecondLevelVerify TaxAmount/41,3,Invoice Print Date/42,3,Invoice Print By/43,3,Invoice Send Party Date/44,3,Invoice Send Party By",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "BillDep", totalNumberOfColumn: 45, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexportExcelProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);

  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const ediLocSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { ediLocOnchange(e.target.value) }} />
  }
  const CusNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { CusNmOnchange(e.target.value) }} />
  }
  //
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const ediLocOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.customPointName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const CusNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.importer_name.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>BILLING DEPARTMENT EMPLOYEE REPORT</center></div>
            <Row>
              <Col><center>
                <label style={mystyle1}>FromDate</label>
                <Form.Control size="sm" type="date" style={mystyle} value={billEmpValues.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>ToDate</label>
                <Form.Control size="sm" type="date" style={mystyle} value={billEmpValues.to} onChange={tohandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>BranchName</label>
                <Form.Select size="sm" style={mystyle} value={billEmpValues.branch} onChange={branchhandlechange}>
                  {details1.map(trns => (
                    <option value={trns.regionId}>{trns.regionalName}</option>
                  ))}
                </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>EmployeeName</label>
                <Form.Select size="sm" style={mystyle} value={billEmpValues.empname} onChange={empnmhandlechange}>
                  {details2.map(trns => (
                    <option value={trns.employeeId}>{trns.employeeName}</option>
                  ))}
                </Form.Select></center>
              </Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" onClick={showBtnClick}> {showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={ExportExcelClick}> {exportExcelProcs ? 'processing...' : 'Export Excel'} </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 410 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>Operation</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobStatus</StyledTableCell>
                      <StyledTableCell>Branch</StyledTableCell>
                      <StyledTableCell>EDI_Location{ediLocSrch()}</StyledTableCell>
                      <StyledTableCell>CustomerName{CusNmSrch()}</StyledTableCell>
                      <StyledTableCell>ForwarderName</StyledTableCell>
                      <StyledTableCell>MAWB_Mbl_No</StyledTableCell>
                      <StyledTableCell>MAWB_Mbl_Date</StyledTableCell>
                      <StyledTableCell>HAWB_Mbl_No</StyledTableCell>
                      <StyledTableCell>HAWB_Mbl_Date</StyledTableCell>
                      <StyledTableCell>IGM_No</StyledTableCell>
                      <StyledTableCell>IGM_Date</StyledTableCell>
                      <StyledTableCell>Total_Pcs</StyledTableCell>
                      <StyledTableCell>Total_WT</StyledTableCell>
                      <StyledTableCell>BE_SB_Type</StyledTableCell>
                      <StyledTableCell>BE_SB_No</StyledTableCell>
                      <StyledTableCell>BE_SB_Date</StyledTableCell>
                      <StyledTableCell>No_Of_Invoice</StyledTableCell>
                      <StyledTableCell>Tot_Inv_Value</StyledTableCell>
                      <StyledTableCell>No_Of_Item</StyledTableCell>
                      <StyledTableCell>Assessible_Value</StyledTableCell>
                      <StyledTableCell>Duty_Amount</StyledTableCell>
                      <StyledTableCell>DrawBack_Amount</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>Bill_GenerateDate</StyledTableCell>
                      <StyledTableCell>Bill_GenerateBy</StyledTableCell>
                      <StyledTableCell>Bill_TaxableAmt</StyledTableCell>
                      <StyledTableCell>Bill_NonTaxableAmt</StyledTableCell>
                      <StyledTableCell>Bill_TaxAmt</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_Date</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_By</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_TaxableAmt</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_NonTaxableAmt</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_TaxAmt</StyledTableCell>
                      <StyledTableCell>2ndLvlVerify_Date</StyledTableCell>
                      <StyledTableCell>2ndLvlVerify_By</StyledTableCell>
                      <StyledTableCell>2ndLvlVerify_TaxableAmt</StyledTableCell>
                      <StyledTableCell>2ndLvlVerify_NonTaxableAmt</StyledTableCell>
                      <StyledTableCell>2ndLvlVerify_TaxAmt</StyledTableCell>
                      <StyledTableCell>InvoicePrintDate</StyledTableCell>
                      <StyledTableCell>InvoicePrintBy</StyledTableCell>
                      <StyledTableCell>InvoiceSendPartyDate</StyledTableCell>
                      <StyledTableCell>InvoiceSendParty</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.status}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.customPointName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.forwarder_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawb_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalPcs}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalInvoice}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalCarton}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.assbleValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dutyAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.drawbackAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billGenDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billGenBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billTaxable}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billNonTaxable}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billTax}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelVeryDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelVeryBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelVeryTaxable}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelVeryNonTaxable}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelVeryTax}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelVeryDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelVeryBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelVeryTaxable}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelVeryNonTaxable}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelVeryTax}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoicePrintDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoicePrintBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceSendPartyDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceSendPartyBy}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default BillingDepartmentEmployeeReport;
